import { render, staticRenderFns } from "./ManagePreRegister.vue?vue&type=template&id=958668d2&scoped=true"
import script from "./ManagePreRegister.vue?vue&type=script&lang=js"
export * from "./ManagePreRegister.vue?vue&type=script&lang=js"
import style0 from "./ManagePreRegister.vue?vue&type=style&index=0&id=958668d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958668d2",
  null
  
)

export default component.exports